module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-player"
  }, [_c('video-player', {
    ref: "videoPlayer",
    staticClass: "video-player-box",
    attrs: {
      "options": _vm.playerOptions,
      "playsinline": true,
      "customEventName": "customstatechangedeventname"
    },
    on: {
      "play": function($event) {
        return _vm.onPlayerPlay($event)
      },
      "pause": function($event) {
        return _vm.onPlayerPause($event)
      },
      "statechanged": function($event) {
        return _vm.playerStateChanged($event)
      },
      "ready": _vm.playerReadied
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fbdb50e8"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/video-view/video-player.vue
// module id = 297
// module chunks = 107